// Typy generované z DB schémy

export type PoziciaHraca = "brankar" | "obranca" | "utocnik";
export type strana_hokejky = "L" | "P";
export type stav_zdravia = "fit" | "zraneny" | "otaznik" | "nezname";
export type Rola = "pouzivatel" | "admin";
export type FazaTurnaja =
  | "zakladna"
  | "kvalifikacia"
  | "osemfinale"
  | "stvrfinale"
  | "semifinale"
  | "bronz"
  | "finale";
export type StavZapasu = "planovaný" | "prebieha" | "ukonceny" | "zruseny";

export interface Profil {
  id: string;
  email: string;
  zobrazovane_meno: string | null;
  rola: Rola;
  vytvorene: string;
  avatar_url: string | null;
  avatar_verzia: number;
}

export interface Hlasovanie {
  id: string;
  nazov: string;
  popis: string | null;
  zaciatok: string;
  koniec: string;
  je_aktivne: boolean;
  vytvorene: string;
  vytvoril_profil_id: string;
}

export interface PravidloPozicie {
  id: string;
  hlasovanie_id: string;
  pozicia: PoziciaHraca;
  pocet_slotov: number;
  poradie: number;
}

export interface Hrac {
  id: string;
  cele_meno: string;
  pozicia: PoziciaHraca;
  sutaz: string | null;
  klub: string | null;
  strana_hokejky: strana_hokejky | null;
  datum_narodenia: string | null;
  prijem: number;
  hodnota_hraca: number;
  sezona_zapasy: number;
  sezona_goly: number;
  sezona_asistencie: number;
  sezona_body: number;
  poznamka: string | null;
  vytvorene: string;
  pocet_vyberov?: number;
  avatar_url: string | null;
  avatar_verzia: number;
  miesto_narodenia: string | null;
  vyska_cm: number | null;
  hmotnost_kg: number | null;
  kariera_prehlad: string | null;
  reprezentacne_skusenosti: string | null;
  zmluva_info: string | null;
  cislo: number | null;
}

export interface Kandidat {
  id: string;
  hlasovanie_id: string;
  hrac_id: string;
  je_v_dispozicii: boolean;
  stav_zdravia: stav_zdravia;
  poznamka_zdravie: string | null;
  je_zobrazovat: boolean;
}

export interface Hlas {
  id: string;
  hlasovanie_id: string;
  profil_id: string;
  vytvorene: string;
  nazov_nominacie: string | null;
}

export interface Vyber {
  id: string;
  hlas_id: string;
  pozicia: PoziciaHraca;
  slot: number;
  kandidat_id: string;
}

export interface LogUdalosti {
  id: string;
  profil_id: string | null;
  hlasovanie_id: string | null;
  typ: string;
  detail: string | null;
  vytvorene: string;
}

export interface NavrhHraca {
  id: string;
  cele_meno: string;
  pozicia: PoziciaHraca;
  sutaz: string | null;
  klub: string | null;
  strana_hokejky: strana_hokejky | null;
  datum_narodenia: string | null;
  prijem: number;
  hodnota_hraca: number;
  poznamka: string | null;
  navrhnute_profil_id: string;
  schvalene_profil_id: string | null;
  je_schvalene: boolean;
  poznamka_admin: string | null;
  vytvorene: string;
  schvalene: string | null;
  avatar_url: string | null;
  avatar_verzia: number;
}

export interface Krajina {
  id: string;
  nazov: string;
  kod: string;
  vlajka_emoji: string | null;
  vytvorene: string;
  hlavny_trener: string | null;
  asistenti: string[] | null;
  generalny_manazer: string | null;
  iihf_rebricek: number | null;
  vysledky_posledny_ms: string | null;
  forma_posledna_sezona: string | null;
}

export interface Skupina {
  id: string;
  nazov: string;
  rok: number;
  poradie: number;
  slug: string;
  vytvorene: string;
}

export interface KrajinaSkupina {
  id: string;
  krajina_id: string;
  skupina_id: string;
  poradie: number;
  body: number;
  vyhry: number;
  prehry: number;
  remizy_sn: number;
  skore_za: number;
  skore_priem: number;
  vyhry_regulerne: number;
  vyhry_predlzenie: number;
  prehry_predlzenie: number;
  prehry_regulerne: number;
  zapasy_celkom: number;
  rozdiel_golov: number;
}

export interface Zapas {
  id: string;
  skupina_id: string | null;
  faza: FazaTurnaja;
  domaci_krajina_id: string;
  hosti_krajina_id: string;
  datum_cas: string;
  miesto: string | null;
  skore_domaci: number | null;
  skore_hosti: number | null;
  stav: StavZapasu;
  poznamka: string | null;
  vytvorene: string;
  predlzenie: boolean;
  najazdy: boolean;
  skore_domaci_po_60min: number | null;
  skore_hosti_po_60min: number | null;
}

export interface NominaciaKrajina {
  id: string;
  krajina_id: string;
  cele_meno: string;
  pozicia: PoziciaHraca;
  klub: string | null;
  sutaz: string | null;
  cislo: number | null;
  strana_hokejky: strana_hokejky | null;
  datum_narodenia: string | null;
  prijem: number;
  hodnota_hraca: number;
  poznamka: string | null;
  vytvorene: string;
  sezona_zapasy: number;
  sezona_goly: number;
  sezona_asistencie: number;
  sezona_body: number;
  avatar_url: string | null;
  avatar_verzia: number;
  miesto_narodenia: string | null;
  vyska_cm: number | null;
  hmotnost_kg: number | null;
  kariera_prehlad: string | null;
  reprezentacne_skusenosti: string | null;
  zmluva_info: string | null;
}

export interface Gol {
  id: string;
  zapas_id: string;
  krajina_id: string;
  hrac_meno: string;
  cas: string | null;
  tretina: number | null;
  typ: string | null;
  asistenti: string[];
  vytvorene: string;
}

export interface Trest {
  id: string;
  zapas_id: string;
  krajina_id: string;
  hrac_meno: string;
  cas: string | null;
  tretina: number | null;
  typ_trestu: string;
  minuty: number;
  vytvorene: string;
}

export interface CelkovePoradie {
  id: string;
  krajina_id: string;
  skupina_id: string;
  poradie: number;
  poradie_v_skupine: number;
  body: number;
  rozdiel_golov: number;
  goly_strelene: number;
  iihf_ranking: number | null;
  vytvorene: string;
  aktualizovane: string;
}

export interface ZapasStatistikyTim {
  id: string;
  zapas_id: string;
  krajina_id: string;
  strely_na_branku: number;
  strely_mimo: number;
  zablokovane_strely: number;
  zakroky_brankara: number;
  vylucenia: number;
  vylucenia_minuty: number;
  vyhrate_vhadzovania: number;
  vhadzovania_percento: number;
  goly_v_presilovke: number;
  goly_v_oslabeni: number;
  vytvorene: string;
}

export interface ZapasHracStatistiky {
  id: string;
  zapas_id: string;
  krajina_id: string;
  hrac_meno: string;
  goly: number;
  asistencie: number;
  body: number;
  plus_minus: number;
  trestne_minuty: number;
  strely: number;
  vhadzovania_vyhrate: number;
  vhadzovania_prehrate: number;
  cas_na_lade: string | null;
  vytvorene: string;
}

export interface ZapasZostava {
  id: string;
  zapas_id: string;
  krajina_id: string;
  hrac_meno: string;
  pozicia_v_zostave: string | null;
  formacia: number | null;
  je_kapitan: boolean;
  je_asistent: boolean;
  vytvorene: string;
}

export interface Clanok {
  id: string;
  slug: string;
  titulok: string;
  perex: string | null;
  obsah: string;
  autor: string;
  autor_role: string | null;
  datum_cas: string;
  cas_citania: number;
  je_aktivne: boolean;
  obrazok_url: string | null;
  meta_titulok: string | null;
  meta_popis: string | null;
  kategorie: string[];
  tagy: string[];
  vytvorene: string;
  aktualizovane: string;
}

export interface ClanokVerejny {
  id: string;
  slug: string;
  titulok: string;
  perex: string | null;
  obsah: string;
  autor: string;
  autor_role: string | null;
  datum_cas: string;
  cas_citania: number;
  obrazok_url: string | null;
  meta_titulok: string | null;
  meta_popis: string | null;
  kategorie: string[];
  tagy: string[];
}

export interface Nahradnik {
  id: string;
  hrac_id: string;
  pozicia: PoziciaHraca;
  datum_pridania: string;
  poznamka: string | null;
  je_aktivny: boolean;
  vytvorene: string;
  aktualizovane: string;
}

export interface NahradnikDetail extends Nahradnik {
  hrac: Hrac;
  vek: number | null;
}

// Rozšírené typy s joinmi
export interface ZapasSKrajinami extends Zapas {
  domaciKrajina: Krajina;
  hostiKrajina: Krajina;
}

export interface SkupinaSKrajinami extends Skupina {
  krajiny: (KrajinaSkupina & { krajina: Krajina })[];
}

export interface KrajinaSNominaciou extends Krajina {
  nominacia: NominaciaKrajina[];
}

export interface HracKomplet {
  id: string;
  cele_meno: string;
  pozicia: PoziciaHraca;
  klub: string | null;
  sutaz: string | null;
  strana_hokejky: strana_hokejky | null;
  datum_narodenia: string | null;
  prijem: number | null;
  hodnota_hraca: number | null;
  poznamka: string | null;
  vytvorene: string;
  vek_k_ms: number | null;
  nominacie_krajiny: string | null;
  nominacie_kody: string | null;
  cisla_dresov: string | null;
  priemerny_rating: number;
  pocet_hodnoteni: number;
  pocet_vyberov: number | null;
  sezona_zapasy: number;
  sezona_goly: number;
  sezona_asistencie: number;
  sezona_body: number;
  avatar_url: string | null;
  avatar_verzia: number | null;
  zdroj_povodu: string;
  miesto_narodenia: string | null;
  vyska_cm: number | null;
  hmotnost_kg: number | null;
  kariera_prehlad: string | null;
  reprezentacne_skusenosti: string | null;
  zmluva_info: string | null;
  cislo: number | null;
}

export interface KandidatSHracom extends Kandidat {
  hrac: HracKomplet;
}

export interface VyberSKandidatom extends Vyber {
  kandidat: KandidatSHracom;
}

export interface HlasSVybermi extends Hlas {
  vybery: VyberSKandidatom[];
}

export interface HlasovanieSPravidlami extends Hlasovanie {
  pravidlapozicie: PravidloPozicie[];
}

// Typy pre výsledky
export interface VysledokSlotu {
  pozicia: PoziciaHraca;
  slot: number;
  kandidat_id: string;
  hrac_id: string;
  hrac_meno: string;
  klub: string | null;
  sutaz: string | null;
  datum_narodenia: string | null;
  vek_k_ms: number | null;
  hodnota_hraca: number | null;
  prijem: number | null;
  sezona_zapasy: number | null;
  sezona_goly: number | null;
  sezona_asistencie: number | null;
  sezona_body: number | null;
  pocet_hlasov: number;
  poradie: number;
}

// Typ pre agregované výsledky všetkých hlasovaní
export interface AgregovanyVysledok {
  hrac_id: string;
  cele_meno: string;
  pozice: PoziciaHraca;
  klub: string | null;
  sutaz: string | null;
  celkove_hlasy: number;
  percenta_hlasov: number;
  poradie: number;
  pocet_hlasovani: number;
}

// Spoločný typ pre výsledky (union typ pre kompatibilitu)
export type VysledokHraca = VysledokSlotu | AgregovanyVysledok;

// Helper funkcie pre prácu s union typom
export const getHracId = (vysledok: VysledokHraca): string => vysledok.hrac_id;

export const getHracMeno = (vysledok: VysledokHraca): string =>
  "hrac_meno" in vysledok ? vysledok.hrac_meno : vysledok.cele_meno;

export const getPozicia = (vysledok: VysledokHraca): PoziciaHraca =>
  "pozice" in vysledok ? vysledok.pozice : vysledok.pozicia;

export const getKlub = (vysledok: VysledokHraca): string | null =>
  vysledok.klub;

export const getSutaz = (vysledok: VysledokHraca): string | null =>
  vysledok.sutaz;

export const getPocetHlasov = (vysledok: VysledokHraca): number =>
  "celkove_hlasy" in vysledok ? vysledok.celkove_hlasy : vysledok.pocet_hlasov;

export const getPoradie = (vysledok: VysledokHraca): number => vysledok.poradie;

// Typy pre štatistiky zostavy
export interface DetailZostavy {
  hrac_id: string;
  cele_meno: string;
  datum_narodenia: string | null;
  vek_k_ms: number | null;
  pozicia: PoziciaHraca;
  strana_hokejky: strana_hokejky | null;
  prijem: number;
  hodnota_hraca: number;
  klub: string | null;
  sutaz: string | null;
}

export interface StatistikyZostavy {
  priemerny_vek: number;
  najmladsi_hrac_meno: string | null;
  najmladsi_hrac_vek: number | null;
  najstarsi_hrac_meno: string | null;
  najstarsi_hrac_vek: number | null;
  suma_prijmov: number;
  suma_hodnota_hracov: number;
  pocet_hracov: number;
  suma_zapasy: number;
  suma_goly: number;
  suma_asistencie: number;
  suma_body: number;
}

export interface ZoznamNarodenin {
  hrac_id: string;
  cele_meno: string;
  datum_narodenia: string | null;
  vek_k_ms: number | null;
  pozicia: PoziciaHraca;
  strana_hokejky: strana_hokejky | null;
}

// Typ pre uloženie hlasu
export interface VyberInput {
  pozicia: PoziciaHraca;
  slot: number;
  kandidat_id: string;
}

// Database types pre Supabase
export type Database = {
  public: {
    Tables: {
      profil: {
        Row: {
          id: string;
          email: string;
          zobrazovane_meno: string | null;
          rola: Rola;
          vytvorene: string;
          avatar_url: string | null;
          avatar_verzia: number;
        };
        Insert: {
          id: string;
          email: string;
          zobrazovane_meno?: string | null;
          rola?: Rola;
          vytvorene?: string;
          avatar_url?: string | null;
          avatar_verzia?: number;
        };
        Update: {
          id?: string;
          email?: string;
          zobrazovane_meno?: string | null;
          rola?: Rola;
          vytvorene?: string;
          avatar_url?: string | null;
          avatar_verzia?: number;
        };
        Relationships: [];
      };
      hlasovanie: {
        Row: {
          id: string;
          nazov: string;
          popis: string | null;
          zaciatok: string;
          koniec: string;
          je_aktivne: boolean;
          vytvorene: string;
          vytvoril_profil_id: string;
        };
        Insert: {
          id?: string;
          nazov: string;
          popis?: string | null;
          zaciatok: string;
          koniec: string;
          je_aktivne?: boolean;
          vytvorene?: string;
          vytvoril_profil_id: string;
        };
        Update: {
          id?: string;
          nazov?: string;
          popis?: string | null;
          zaciatok?: string;
          koniec?: string;
          je_aktivne?: boolean;
          vytvorene?: string;
          vytvoril_profil_id?: string;
        };
        Relationships: [];
      };
      pravidlopozicie: {
        Row: {
          id: string;
          hlasovanie_id: string;
          pozicia: PoziciaHraca;
          pocet_slotov: number;
          poradie: number;
        };
        Insert: {
          id?: string;
          hlasovanie_id: string;
          pozicia: PoziciaHraca;
          pocet_slotov: number;
          poradie: number;
        };
        Update: {
          id?: string;
          hlasovanie_id?: string;
          pozicia?: PoziciaHraca;
          pocet_slotov?: number;
          poradie?: number;
        };
        Relationships: [];
      };
      hrac: {
        Row: {
          id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          sutaz: string | null;
          klub: string | null;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          sezona_body: number;
          poznamka: string | null;
          vytvorene: string;
          pocet_vyberov?: number;
          avatar_url: string | null;
          avatar_verzia: number;
          miesto_narodenia: string | null;
          vyska_cm: number | null;
          hmotnost_kg: number | null;
          kariera_prehlad: string | null;
          reprezentacne_skusenosti: string | null;
          zmluva_info: string | null;
          cislo: number | null;
        };
        Insert: {
          id?: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          sutaz?: string | null;
          klub?: string | null;
          strana_hokejky?: strana_hokejky | null;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          sezona_zapasy?: number;
          sezona_goly?: number;
          sezona_asistencie?: number;
          sezona_body?: number;
          poznamka?: string | null;
          vytvorene?: string;
          avatar_url?: string | null;
          avatar_verzia?: number;
          miesto_narodenia?: string | null;
          vyska_cm?: number | null;
          hmotnost_kg?: number | null;
          kariera_prehlad?: string | null;
          reprezentacne_skusenosti?: string | null;
          zmluva_info?: string | null;
          cislo?: number | null;
        };
        Update: {
          id?: string;
          cele_meno?: string;
          pozicia?: PoziciaHraca;
          sutaz?: string | null;
          klub?: string | null;
          strana_hokejky?: strana_hokejky | null;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          sezona_zapasy?: number;
          sezona_goly?: number;
          sezona_asistencie?: number;
          sezona_body?: number;
          poznamka?: string | null;
          vytvorene?: string;
          avatar_url?: string | null;
          avatar_verzia?: number;
          miesto_narodenia?: string | null;
          vyska_cm?: number | null;
          hmotnost_kg?: number | null;
          kariera_prehlad?: string | null;
          reprezentacne_skusenosti?: string | null;
          zmluva_info?: string | null;
          cislo?: number | null;
        };
        Relationships: [];
      };
      kandidat: {
        Row: {
          id: string;
          hlasovanie_id: string;
          hrac_id: string;
          je_v_dispozicii: boolean;
          stav_zdravia: stav_zdravia;
          poznamka_zdravie: string | null;
          je_zobrazovat: boolean;
        };
        Insert: {
          id?: string;
          hlasovanie_id: string;
          hrac_id: string;
          je_v_dispozicii?: boolean;
          stav_zdravia?: stav_zdravia;
          poznamka_zdravie?: string | null;
          je_zobrazovat?: boolean;
        };
        Update: {
          id?: string;
          hlasovanie_id?: string;
          hrac_id?: string;
          je_v_dispozicii?: boolean;
          stav_zdravia?: stav_zdravia;
          poznamka_zdravie?: string | null;
          je_zobrazovat?: boolean;
        };
        Relationships: [
          {
            foreignKeyName: "kandidat_hrac_id_fkey";
            columns: ["hrac_id"];
            isOneToOne: false;
            referencedRelation: "hrac";
            referencedColumns: ["id"];
          },
          {
            foreignKeyName: "kandidat_hlasovanie_id_fkey";
            columns: ["hlasovanie_id"];
            isOneToOne: false;
            referencedRelation: "hlasovanie";
            referencedColumns: ["id"];
          },
        ];
      };
      hlas: {
        Row: {
          id: string;
          hlasovanie_id: string;
          profil_id: string;
          vytvorene: string;
          nazov_nominacie: string | null;
        };
        Insert: {
          id?: string;
          hlasovanie_id: string;
          profil_id: string;
          vytvorene?: string;
          nazov_nominacie?: string | null;
        };
        Update: {
          id?: string;
          hlasovanie_id?: string;
          profil_id?: string;
          vytvorene?: string;
          nazov_nominacie?: string | null;
        };
        Relationships: [];
      };
      vyber: {
        Row: {
          id: string;
          hlas_id: string;
          pozicia: PoziciaHraca;
          slot: number;
          kandidat_id: string;
        };
        Insert: {
          id?: string;
          hlas_id: string;
          pozicia: PoziciaHraca;
          slot: number;
          kandidat_id: string;
        };
        Update: {
          id?: string;
          hlas_id?: string;
          pozicia?: PoziciaHraca;
          slot?: number;
          kandidat_id?: string;
        };
        Relationships: [];
      };
      logudalosti: {
        Row: {
          id: string;
          profil_id: string | null;
          hlasovanie_id: string | null;
          typ: string;
          detail: string | null;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          profil_id?: string | null;
          hlasovanie_id?: string | null;
          typ: string;
          detail?: string | null;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          profil_id?: string | null;
          hlasovanie_id?: string | null;
          typ?: string;
          detail?: string | null;
          vytvorene?: string;
        };
        Relationships: [];
      };
      navrhhraca: {
        Row: {
          id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          sutaz: string | null;
          klub: string | null;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          poznamka: string | null;
          navrhnute_profil_id: string;
          schvalene_profil_id: string | null;
          je_schvalene: boolean;
          poznamka_admin: string | null;
          vytvorene: string;
          schvalene: string | null;
          avatar_url: string | null;
          avatar_verzia: number;
        };
        Insert: {
          id?: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          sutaz?: string | null;
          klub?: string | null;
          strana_hokejky?: strana_hokejky | null;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          poznamka?: string | null;
          navrhnute_profil_id: string;
          schvalene_profil_id?: string | null;
          je_schvalene?: boolean;
          poznamka_admin?: string | null;
          vytvorene?: string;
          schvalene?: string | null;
          avatar_url?: string | null;
          avatar_verzia?: number;
        };
        Update: {
          id?: string;
          cele_meno?: string;
          pozicia?: PoziciaHraca;
          sutaz?: string | null;
          klub?: string | null;
          strana_hokejky?: strana_hokejky | null;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          poznamka?: string | null;
          navrhnute_profil_id?: string;
          schvalene_profil_id?: string | null;
          je_schvalene?: boolean;
          poznamka_admin?: string | null;
          vytvorene?: string;
          schvalene?: string | null;
          avatar_url?: string | null;
          avatar_verzia?: number;
        };
        Relationships: [
          {
            foreignKeyName: "navrhhraca_navrhnuteprofil_id_fkey";
            columns: ["navrhnute_profil_id"];
            isOneToOne: false;
            referencedRelation: "profil";
            referencedColumns: ["id"];
          },
          {
            foreignKeyName: "navrhhraca_schvaleneProfidlId_fkey";
            columns: ["schvalene_profil_id"];
            isOneToOne: false;
            referencedRelation: "profil";
            referencedColumns: ["id"];
          },
        ];
      };
      hodnotenie: {
        Row: {
          id: string;
          zapas_id: string;
          hrac_id: string;
          profil_id: string;
          rating: number;
          komentar: string | null;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          hrac_id: string;
          profil_id: string;
          rating: number;
          komentar?: string | null;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          hrac_id?: string;
          profil_id?: string;
          rating?: number;
          komentar?: string | null;
          vytvorene?: string;
        };
        Relationships: [
          {
            foreignKeyName: "hodnotenie_zapas_id_fkey";
            columns: ["zapas_id"];
            isOneToOne: false;
            referencedRelation: "zapas";
            referencedColumns: ["id"];
          },
          {
            foreignKeyName: "hodnotenie_hrac_id_fkey";
            columns: ["hrac_id"];
            isOneToOne: false;
            referencedRelation: "hrac";
            referencedColumns: ["id"];
          },
          {
            foreignKeyName: "hodnotenie_profil_id_fkey";
            columns: ["profil_id"];
            isOneToOne: false;
            referencedRelation: "profil";
            referencedColumns: ["id"];
          },
        ];
      };
      krajina: {
        Row: {
          id: string;
          nazov: string;
          kod: string;
          vlajka_emoji: string | null;
          vytvorene: string;
          hlavny_trener: string | null;
          asistenti: string[] | null;
          generalny_manazer: string | null;
          iihf_rebricek: number | null;
          vysledky_posledny_ms: string | null;
          forma_posledna_sezona: string | null;
        };
        Insert: {
          id?: string;
          nazov: string;
          kod: string;
          vlajka_emoji?: string | null;
          vytvorene?: string;
          hlavny_trener?: string | null;
          asistenti?: string[] | null;
          generalny_manazer?: string | null;
          iihf_rebricek?: number | null;
          vysledky_posledny_ms?: string | null;
          forma_posledna_sezona?: string | null;
        };
        Update: {
          id?: string;
          nazov?: string;
          kod?: string;
          vlajka_emoji?: string | null;
          vytvorene?: string;
          hlavny_trener?: string | null;
          asistenti?: string[] | null;
          generalny_manazer?: string | null;
          iihf_rebricek?: number | null;
          vysledky_posledny_ms?: string | null;
          forma_posledna_sezona?: string | null;
        };
        Relationships: [];
      };
      skupina: {
        Row: {
          id: string;
          nazov: string;
          rok: number;
          poradie: number;
          slug: string;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          nazov: string;
          rok?: number;
          poradie: number;
          slug: string;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          nazov?: string;
          rok?: number;
          poradie?: number;
          slug?: string;
          vytvorene?: string;
        };
        Relationships: [];
      };
      krajinaskupina: {
        Row: {
          id: string;
          krajina_id: string;
          skupina_id: string;
          poradie: number;
          body: number;
          vyhry: number;
          prehry: number;
          remizy_sn: number;
          skore_za: number;
          skore_priem: number;
          vyhry_regulerne: number;
          vyhry_predlzenie: number;
          prehry_predlzenie: number;
          prehry_regulerne: number;
          zapasy_celkom: number;
          rozdiel_golov: number;
        };
        Insert: {
          id?: string;
          krajina_id: string;
          skupina_id: string;
          poradie?: number;
          body?: number;
          vyhry?: number;
          prehry?: number;
          remizy_sn?: number;
          skore_za?: number;
          skore_priem?: number;
          vyhry_regulerne?: number;
          vyhry_predlzenie?: number;
          prehry_predlzenie?: number;
          prehry_regulerne?: number;
          zapasy_celkom?: number;
          rozdiel_golov?: number;
        };
        Update: {
          id?: string;
          krajina_id?: string;
          skupina_id?: string;
          poradie?: number;
          body?: number;
          vyhry?: number;
          prehry?: number;
          remizy_sn?: number;
          skore_za?: number;
          skore_priem?: number;
          vyhry_regulerne?: number;
          vyhry_predlzenie?: number;
          prehry_predlzenie?: number;
          prehry_regulerne?: number;
          zapasy_celkom?: number;
          rozdiel_golov?: number;
        };
        Relationships: [];
      };
      zapas: {
        Row: {
          id: string;
          skupina_id: string | null;
          faza: FazaTurnaja;
          domaci_krajina_id: string;
          hosti_krajina_id: string;
          datum_cas: string;
          miesto: string | null;
          skore_domaci: number | null;
          skore_hosti: number | null;
          stav: StavZapasu;
          poznamka: string | null;
          vytvorene: string;
          predlzenie: boolean;
          najazdy: boolean;
          skore_domaci_po_60min: number | null;
          skore_hosti_po_60min: number | null;
        };
        Insert: {
          id?: string;
          skupina_id?: string | null;
          faza?: FazaTurnaja;
          domaci_krajina_id: string;
          hosti_krajina_id: string;
          datum_cas: string;
          miesto?: string | null;
          skore_domaci?: number | null;
          skore_hosti?: number | null;
          stav?: StavZapasu;
          poznamka?: string | null;
          vytvorene?: string;
          predlzenie?: boolean;
          najazdy?: boolean;
          skore_domaci_po_60min?: number | null;
          skore_hosti_po_60min?: number | null;
        };
        Update: {
          id?: string;
          skupina_id?: string | null;
          faza?: FazaTurnaja;
          domaci_krajina_id?: string;
          hosti_krajina_id?: string;
          datum_cas?: string;
          miesto?: string | null;
          skore_domaci?: number | null;
          skore_hosti?: number | null;
          stav?: StavZapasu;
          poznamka?: string | null;
          vytvorene?: string;
          predlzenie?: boolean;
          najazdy?: boolean;
          skore_domaci_po_60min?: number | null;
          skore_hosti_po_60min?: number | null;
        };
        Relationships: [];
      };
      nominaciakrajina: {
        Row: {
          id: string;
          krajina_id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          klub: string | null;
          sutaz: string | null;
          cislo: number | null;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          poznamka: string | null;
          vytvorene: string;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          sezona_body: number;
          avatar_url: string | null;
          avatar_verzia: number;
          miesto_narodenia: string | null;
          vyska_cm: number | null;
          hmotnost_kg: number | null;
          kariera_prehlad: string | null;
          reprezentacne_skusenosti: string | null;
          zmluva_info: string | null;
        };
        Insert: {
          id?: string;
          krajina_id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          klub?: string | null;
          sutaz?: string | null;
          cislo?: number | null;
          strana_hokejky?: strana_hokejky | null;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          poznamka?: string | null;
          vytvorene?: string;
          sezona_zapasy?: number;
          sezona_goly?: number;
          sezona_asistencie?: number;
          sezona_body?: number;
          avatar_url?: string | null;
          avatar_verzia?: number;
          miesto_narodenia?: string | null;
          vyska_cm?: number | null;
          hmotnost_kg?: number | null;
          kariera_prehlad?: string | null;
          reprezentacne_skusenosti?: string | null;
          zmluva_info?: string | null;
        };
        Update: {
          id?: string;
          krajina_id?: string;
          cele_meno?: string;
          pozicia?: PoziciaHraca;
          klub?: string | null;
          sutaz?: string | null;
          cislo?: number | null;
          strana_hokejky?: strana_hokejky;
          datum_narodenia?: string | null;
          prijem?: number;
          hodnota_hraca?: number;
          poznamka?: string | null;
          vytvorene?: string;
          sezona_zapasy?: number;
          sezona_goly?: number;
          sezona_asistencie?: number;
          sezona_body?: number;
          avatar_url?: string | null;
          avatar_verzia?: number;
          miesto_narodenia?: string | null;
          vyska_cm?: number | null;
          hmotnost_kg?: number | null;
          kariera_prehlad?: string | null;
          reprezentacne_skusenosti?: string | null;
          zmluva_info?: string | null;
        };
        Relationships: [];
      };
      clanky: {
        Row: {
          id: string;
          slug: string;
          titulok: string;
          perex: string | null;
          obsah: string;
          autor: string;
          autor_role: string | null;
          datum_cas: string;
          cas_citania: number;
          je_aktivne: boolean;
          obrazok_url: string | null;
          meta_titulok: string | null;
          meta_popis: string | null;
          kategorie: string[];
          tagy: string[];
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: string;
          slug?: string;
          titulok: string;
          perex?: string | null;
          obsah: string;
          autor: string;
          autor_role?: string | null;
          datum_cas?: string;
          cas_citania?: number;
          je_aktivne?: boolean;
          obrazok_url?: string | null;
          meta_titulok?: string | null;
          meta_popis?: string | null;
          kategorie?: string[];
          tagy?: string[];
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: string;
          slug?: string;
          titulok?: string;
          perex?: string | null;
          obsah?: string;
          autor?: string;
          autor_role?: string | null;
          datum_cas?: string;
          cas_citania?: number;
          je_aktivne?: boolean;
          obrazok_url?: string | null;
          meta_titulok?: string | null;
          meta_popis?: string | null;
          kategorie?: string[];
          tagy?: string[];
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [];
      };
      gol: {
        Row: {
          id: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          cas: string | null;
          tretina: number | null;
          typ: string | null;
          asistenti: string[];
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          cas?: string | null;
          tretina?: number | null;
          typ?: string | null;
          asistenti?: string[];
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          krajina_id?: string;
          hrac_meno?: string;
          cas?: string | null;
          tretina?: number | null;
          typ?: string | null;
          asistenti?: string[];
          vytvorene?: string;
        };
        Relationships: [];
      };
      trest: {
        Row: {
          id: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          cas: string | null;
          tretina: number | null;
          typ_trestu: string;
          minuty: number;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          cas?: string | null;
          tretina?: number | null;
          typ_trestu: string;
          minuty?: number;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          krajina_id?: string;
          hrac_meno?: string;
          cas?: string | null;
          tretina?: number | null;
          typ_trestu?: string;
          minuty?: number;
          vytvorene?: string;
        };
        Relationships: [];
      };
      celkoveporadie: {
        Row: {
          id: string;
          krajina_id: string;
          skupina_id: string;
          poradie: number;
          poradie_v_skupine: number;
          body: number;
          rozdiel_golov: number;
          goly_strelene: number;
          iihf_ranking: number | null;
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: string;
          krajina_id: string;
          skupina_id: string;
          poradie: number;
          poradie_v_skupine: number;
          body: number;
          rozdiel_golov: number;
          goly_strelene: number;
          iihf_ranking?: number | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: string;
          krajina_id?: string;
          skupina_id?: string;
          poradie?: number;
          poradie_v_skupine?: number;
          body?: number;
          rozdiel_golov?: number;
          goly_strelene?: number;
          iihf_ranking?: number | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [];
      };
      zapas_statistiky_tim: {
        Row: {
          id: string;
          zapas_id: string;
          krajina_id: string;
          strely_na_branku: number;
          strely_mimo: number;
          zablokovane_strely: number;
          zakroky_brankara: number;
          vylucenia: number;
          vylucenia_minuty: number;
          vyhrate_vhadzovania: number;
          vhadzovania_percento: number;
          goly_v_presilovke: number;
          goly_v_oslabeni: number;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          krajina_id: string;
          strely_na_branku?: number;
          strely_mimo?: number;
          zablokovane_strely?: number;
          zakroky_brankara?: number;
          vylucenia?: number;
          vylucenia_minuty?: number;
          vyhrate_vhadzovania?: number;
          vhadzovania_percento?: number;
          goly_v_presilovke?: number;
          goly_v_oslabeni?: number;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          krajina_id?: string;
          strely_na_branku?: number;
          strely_mimo?: number;
          zablokovane_strely?: number;
          zakroky_brankara?: number;
          vylucenia?: number;
          vylucenia_minuty?: number;
          vyhrate_vhadzovania?: number;
          vhadzovania_percento?: number;
          goly_v_presilovke?: number;
          goly_v_oslabeni?: number;
          vytvorene?: string;
        };
        Relationships: [];
      };
      zapas_hrac_statistiky: {
        Row: {
          id: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          goly: number;
          asistencie: number;
          body: number;
          plus_minus: number;
          trestne_minuty: number;
          strely: number;
          vhadzovania_vyhrate: number;
          vhadzovania_prehrate: number;
          cas_na_lade: string | null;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          goly?: number;
          asistencie?: number;
          body?: number;
          plus_minus?: number;
          trestne_minuty?: number;
          strely?: number;
          vhadzovania_vyhrate?: number;
          vhadzovania_prehrate?: number;
          cas_na_lade?: string | null;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          krajina_id?: string;
          hrac_meno?: string;
          goly?: number;
          asistencie?: number;
          body?: number;
          plus_minus?: number;
          trestne_minuty?: number;
          strely?: number;
          vhadzovania_vyhrate?: number;
          vhadzovania_prehrate?: number;
          cas_na_lade?: string | null;
          vytvorene?: string;
        };
        Relationships: [];
      };
      zapas_zostava: {
        Row: {
          id: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          pozicia_v_zostave: string | null;
          formacia: number | null;
          je_kapitan: boolean;
          je_asistent: boolean;
          vytvorene: string;
        };
        Insert: {
          id?: string;
          zapas_id: string;
          krajina_id: string;
          hrac_meno: string;
          pozicia_v_zostave?: string | null;
          formacia?: number | null;
          je_kapitan?: boolean;
          je_asistent?: boolean;
          vytvorene?: string;
        };
        Update: {
          id?: string;
          zapas_id?: string;
          krajina_id?: string;
          hrac_meno?: string;
          pozicia_v_zostave?: string | null;
          formacia?: number | null;
          je_kapitan?: boolean;
          je_asistent?: boolean;
          vytvorene?: string;
        };
        Relationships: [];
      };
      nahradnik: {
        Row: {
          id: string;
          hrac_id: string;
          pozicia: PoziciaHraca;
          datum_pridania: string;
          poznamka: string | null;
          je_aktivny: boolean;
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: string;
          hrac_id: string;
          pozicia: PoziciaHraca;
          datum_pridania?: string;
          poznamka?: string | null;
          je_aktivny?: boolean;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: string;
          hrac_id?: string;
          pozicia?: PoziciaHraca;
          datum_pridania?: string;
          poznamka?: string | null;
          je_aktivny?: boolean;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [
          {
            foreignKeyName: "nahradnik_hrac_id_fkey";
            columns: ["hrac_id"];
            isOneToOne: false;
            referencedRelation: "hrac";
            referencedColumns: ["id"];
          },
        ];
      };
    };
    Views: {
      v_admin_zapasy: {
        Row: {
          id: string;
          skupina_id: string | null;
          skupina_nazov: string | null;
          faza: FazaTurnaja;
          domaci_krajina_id: string;
          domaci_nazov: string;
          domaci_kod: string;
          domaci_vlajka_emoji: string | null;
          domaci_hlavny_trener: string | null;
          domaci_asistenti: string[] | null;
          domaci_generalny_manazer: string | null;
          domaci_iihf_rebricek: number | null;
          domaci_vysledky_posledny_ms: string | null;
          domaci_forma_posledna_sezona: string | null;
          domaci_vytvorene: string;
          hosti_krajina_id: string;
          hosti_nazov: string;
          hosti_kod: string;
          hosti_vlajka_emoji: string | null;
          hosti_hlavny_trener: string | null;
          hosti_asistenti: string[] | null;
          hosti_generalny_manazer: string | null;
          hosti_iihf_rebricek: number | null;
          hosti_vysledky_posledny_ms: string | null;
          hosti_forma_posledna_sezona: string | null;
          hosti_vytvorene: string;
          datum_cas: string;
          miesto: string | null;
          skore_domaci: number | null;
          skore_hosti: number | null;
          stav: StavZapasu;
          poznamka: string | null;
          vytvorene: string;
        };
        Relationships: [];
      };
      v_admin_kandidati: {
        Row: {
          id: string;
          hlasovanie_id: string;
          hlasovanie_nazov: string;
          hrac_id: string;
          cele_meno: string;
          klub: string | null;
          sutaz: string | null;
          pozicia: PoziciaHraca;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          je_v_dispozicii: boolean;
          stav_zdravia: stav_zdravia;
          poznamka_zdravie: string | null;
          je_zobrazovat: boolean;
          vytvorene: string;
          vek_k_ms: number | null;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          sezona_body: number;
          avatar_url: string | null;
          avatar_verzia: number | null;
          zdroj_povodu: string;
          miesto_narodenia: string | null;
          vyska_cm: number | null;
          hmotnost_kg: number | null;
          kariera_prehlad: string | null;
          reprezentacne_skusenosti: string | null;
          zmluva_info: string | null;
          cislo: number | null;
        };
        Relationships: [];
      };
      v_hraci_komplet: {
        Row: {
          id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          klub: string | null;
          sutaz: string | null;
          vytvorene: string;
          strana_hokejky: strana_hokejky | null;
          pocet_vyberov: number | null;
          datum_narodenia: string | null;
          prijem: number | null;
          hodnota_hraca: number | null;
          poznamka: string | null;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          sezona_body: number;
          vek_k_ms: number | null;
          nominacie_krajiny: string | null;
          nominacie_kody: string | null;
          cisla_dresov: string | null;
          priemerny_rating: number;
          pocet_hodnoteni: number;
          avatar_url: string | null;
          avatar_verzia: number | null;
          zdroj_povodu: string;
          miesto_narodenia: string | null;
          vyska_cm: number | null;
          hmotnost_kg: number | null;
          kariera_prehlad: string | null;
          reprezentacne_skusenosti: string | null;
          zmluva_info: string | null;
          cislo: number | null;
        };
        Relationships: [];
      };
      vysledky_hlasov: {
        Row: {
          pozicia: PoziciaHraca | null;
          slot: number | null;
          kandidat_id: string | null;
          hrac_id: string | null;
          hrac_meno: string | null;
          klub: string | null;
          sutaz: string | null;
          hlasovanie_id: string | null;
          pocet_hlasov: number | null;
          vek_k_ms: number | null;
          hodnota_hraca: number | null;
          prijem: number | null;
          sezona_zapasy: number | null;
          sezona_goly: number | null;
          sezona_asistencie: number | null;
          sezona_body: number | null;
          avatar_url: string | null;
          avatar_verzia: number | null;
        };
        Relationships: [];
      };
      clanky_verejne: {
        Row: {
          id: string;
          slug: string;
          titulok: string;
          perex: string | null;
          obsah: string;
          autor: string;
          autor_role: string | null;
          datum_cas: string;
          cas_citania: number;
          obrazok_url: string | null;
          meta_titulok: string | null;
          meta_popis: string | null;
          kategorie: string[];
          tagy: string[];
        };
        Relationships: [];
      };
      v_nahradnici_detail: {
        Row: {
          id: string;
          hrac_id: string;
          pozicia: PoziciaHraca;
          datum_pridania: string;
          poznamka: string | null;
          je_aktivny: boolean;
          vytvorene: string;
          aktualizovane: string;
          cele_meno: string;
          klub: string | null;
          sutaz: string | null;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          sezona_body: number;
          avatar_url: string | null;
          avatar_verzia: number | null;
          miesto_narodenia: string | null;
          vyska_cm: number | null;
          hmotnost_kg: number | null;
          kariera_prehlad: string | null;
          reprezentacne_skusenosti: string | null;
          zmluva_info: string | null;
          cislo: number | null;
          vek: number | null;
        };
        Relationships: [];
      };
      // NHL tabuľky
      nhl_tim: {
        Row: {
          id: number;
          espn_tim_id: string;
          nazov: string;
          skratka: string;
          miesto: string | null;
          logo_url: string | null;
          farba_pozadia: string | null;
          farba_alternativa: string | null;
          aktivny: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          espn_tim_id: string;
          nazov: string;
          skratka: string;
          miesto?: string | null;
          logo_url?: string | null;
          farba_pozadia?: string | null;
          farba_alternativa?: string | null;
          aktivny?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          espn_tim_id?: string;
          nazov?: string;
          skratka?: string;
          miesto?: string | null;
          logo_url?: string | null;
          farba_pozadia?: string | null;
          farba_alternativa?: string | null;
          aktivny?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_sezona: {
        Row: {
          id: number;
          rok: number;
          typ: string;
          display_name: string | null;
          zaciatok: string | null;
          koniec: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          rok: number;
          typ: string;
          display_name?: string | null;
          zaciatok?: string | null;
          koniec?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          rok?: number;
          typ?: string;
          display_name?: string | null;
          zaciatok?: string | null;
          koniec?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_zapas: {
        Row: {
          id: number;
          espn_game_id: string;
          sezona_id: number;
          domaci_tim_id: number;
          hostiaci_tim_id: number;
          datum_zaciatku: string;
          datum_konca: string | null;
          stav_typ: string;
          stav_nazov: string;
          stav_skratka: string;
          perioda: number;
          cas_zapasu: string | null;
          cas_ostavajuci: number | null;
          domaci_skore: number;
          hostiaci_skore: number;
          venue_id: string | null;
          venue_nazov: string | null;
          venue_mesto: string | null;
          venue_stat: string | null;
          venue_krajina: string | null;
          venue_interior: boolean;
          venue_kapacita: number | null;
          attendance: number | null;
          neutral_site: boolean;
          play_by_play_available: boolean;
          recent: boolean;
          short_name: string;
          full_name: string;
          notes: unknown[];
          links: Record<string, unknown>;
          first_import: string;
          last_update: string;
          finalized_at: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          espn_game_id: string;
          sezona_id: number;
          domaci_tim_id: number;
          hostiaci_tim_id: number;
          datum_zaciatku: string;
          datum_konca?: string | null;
          stav_typ: string;
          stav_nazov: string;
          stav_skratka: string;
          perioda?: number;
          cas_zapasu?: string | null;
          cas_ostavajuci?: number | null;
          domaci_skore?: number;
          hostiaci_skore?: number;
          venue_id?: string | null;
          venue_nazov?: string | null;
          venue_mesto?: string | null;
          venue_stat?: string | null;
          venue_krajina?: string | null;
          venue_interior?: boolean;
          venue_kapacita?: number | null;
          attendance?: number | null;
          neutral_site?: boolean;
          play_by_play_available?: boolean;
          recent?: boolean;
          short_name: string;
          full_name: string;
          notes?: unknown[];
          links?: Record<string, unknown>;
          first_import?: string;
          last_update?: string;
          finalized_at?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          espn_game_id?: string;
          sezona_id?: number;
          domaci_tim_id?: number;
          hostiaci_tim_id?: number;
          datum_zaciatku?: string;
          datum_konca?: string | null;
          stav_typ?: string;
          stav_nazov?: string;
          stav_skratka?: string;
          perioda?: number;
          cas_zapasu?: string | null;
          cas_ostavajuci?: number | null;
          domaci_skore?: number;
          hostiaci_skore?: number;
          venue_id?: string | null;
          venue_nazov?: string | null;
          venue_mesto?: string | null;
          venue_stat?: string | null;
          venue_krajina?: string | null;
          venue_interior?: boolean;
          venue_kapacita?: number | null;
          attendance?: number | null;
          neutral_site?: boolean;
          play_by_play_available?: boolean;
          recent?: boolean;
          short_name?: string;
          full_name?: string;
          notes?: unknown[];
          links?: Record<string, unknown>;
          first_import?: string;
          last_update?: string;
          finalized_at?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_hrac: {
        Row: {
          id: number;
          espn_hrac_id: string;
          cele_meno: string;
          display_meno: string | null;
          skratka_mena: string | null;
          cislo_dresu: number | null;
          pozicia_skratka: string | null;
          pozicia_nazov: string | null;
          headshot_url: string | null;
          aktivny: boolean;
          aktualny_tim_id: number | null;
          links: Record<string, unknown>;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          espn_hrac_id: string;
          cele_meno: string;
          display_meno?: string | null;
          skratka_mena?: string | null;
          cislo_dresu?: number | null;
          pozicia_skratka?: string | null;
          pozicia_nazov?: string | null;
          headshot_url?: string | null;
          aktivny?: boolean;
          aktualny_tim_id?: number | null;
          links?: Record<string, unknown>;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          espn_hrac_id?: string;
          cele_meno?: string;
          display_meno?: string | null;
          skratka_mena?: string | null;
          cislo_dresu?: number | null;
          pozicia_skratka?: string | null;
          pozicia_nazov?: string | null;
          headshot_url?: string | null;
          aktivny?: boolean;
          aktualny_tim_id?: number | null;
          links?: Record<string, unknown>;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_zapas_tim_statistika: {
        Row: {
          id: number;
          zapas_id: number;
          tim_id: number;
          stat_kluc: string;
          stat_nazov: string | null;
          stat_skratka: string | null;
          stat_hodnota: string | null;
          stat_cislo: number | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          tim_id: number;
          stat_kluc: string;
          stat_nazov?: string | null;
          stat_skratka?: string | null;
          stat_hodnota?: string | null;
          stat_cislo?: number | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          tim_id?: number;
          stat_kluc?: string;
          stat_nazov?: string | null;
          stat_skratka?: string | null;
          stat_hodnota?: string | null;
          stat_cislo?: number | null;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_zapas_lidri: {
        Row: {
          id: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          lider_typ: string;
          lider_nazov: string | null;
          lider_skratka: string | null;
          hodnota: number;
          display_hodnota: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          lider_typ: string;
          lider_nazov?: string | null;
          lider_skratka?: string | null;
          hodnota: number;
          display_hodnota?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          tim_id?: number;
          hrac_id?: number;
          lider_typ?: string;
          lider_nazov?: string | null;
          lider_skratka?: string | null;
          hodnota?: number;
          display_hodnota?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_zapas_zostava: {
        Row: {
          id: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          rola: string | null;
          pozicia_v_zapase: string | null;
          cislo_dresu: number | null;
          aktivny: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          rola?: string | null;
          pozicia_v_zapase?: string | null;
          cislo_dresu?: number | null;
          aktivny?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          tim_id?: number;
          hrac_id?: number;
          rola?: string | null;
          pozicia_v_zapase?: string | null;
          cislo_dresu?: number | null;
          aktivny?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_zapas_hrac_statistika: {
        Row: {
          id: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          stat_kluc: string;
          stat_nazov: string | null;
          stat_skratka: string | null;
          stat_hodnota: string | null;
          stat_cislo: number | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          tim_id: number;
          hrac_id: number;
          stat_kluc: string;
          stat_nazov?: string | null;
          stat_skratka?: string | null;
          stat_hodnota?: string | null;
          stat_cislo?: number | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          tim_id?: number;
          hrac_id?: number;
          stat_kluc?: string;
          stat_nazov?: string | null;
          stat_skratka?: string | null;
          stat_hodnota?: string | null;
          stat_cislo?: number | null;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_play_by_play: {
        Row: {
          id: number;
          zapas_id: number;
          event_id: string | null;
          sekvencia: number;
          perioda: number;
          cas: string | null;
          cas_v_sekundách: number | null;
          typ_udalosti: string | null;
          podtyp: string | null;
          popis: string | null;
          detailny_popis: string | null;
          tim_id: number | null;
          hrac_id: number | null;
          hrac2_id: number | null;
          zona: string | null;
          x_suradnica: number | null;
          y_suradnica: number | null;
          raw_data: Record<string, unknown>;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          event_id?: string | null;
          sekvencia: number;
          perioda: number;
          cas?: string | null;
          cas_v_sekundách?: number | null;
          typ_udalosti?: string | null;
          podtyp?: string | null;
          popis?: string | null;
          detailny_popis?: string | null;
          tim_id?: number | null;
          hrac_id?: number | null;
          hrac2_id?: number | null;
          zona?: string | null;
          x_suradnica?: number | null;
          y_suradnica?: number | null;
          raw_data?: Record<string, unknown>;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          event_id?: string | null;
          sekvencia?: number;
          perioda?: number;
          cas?: string | null;
          cas_v_sekundách?: number | null;
          typ_udalosti?: string | null;
          podtyp?: string | null;
          popis?: string | null;
          detailny_popis?: string | null;
          tim_id?: number | null;
          hrac_id?: number | null;
          hrac2_id?: number | null;
          zona?: string | null;
          x_suradnica?: number | null;
          y_suradnica?: number | null;
          raw_data?: Record<string, unknown>;
          created_at?: string;
          updated_at?: string;
        };
        Relationships: [];
      };
      nhl_import_log: {
        Row: {
          id: number;
          zdroj: string;
          typ_importu: string;
          status: string;
          datum_dátumu: string | null;
          game_ids: unknown[];
          pocet_zapasov: number;
          pocet_hracov: number;
          pocet_statistik: number;
          pocet_play_by_play: number;
          chyby: unknown[];
          error_message: string | null;
          zaciatok: string;
          koniec: string | null;
          trvanie_v_sekundách: number | null;
          created_at: string;
        };
        Insert: {
          id?: number;
          zdroj: string;
          typ_importu: string;
          status: string;
          datum_dátumu?: string | null;
          game_ids?: unknown[];
          pocet_zapasov?: number;
          pocet_hracov?: number;
          pocet_statistik?: number;
          pocet_play_by_play?: number;
          chyby?: unknown[];
          error_message?: string | null;
          zaciatok?: string;
          koniec?: string | null;
          trvanie_v_sekundách?: number | null;
          created_at?: string;
        };
        Update: {
          id?: number;
          zdroj?: string;
          typ_importu?: string;
          status?: string;
          datum_dátumu?: string | null;
          game_ids?: unknown[];
          pocet_zapasov?: number;
          pocet_hracov?: number;
          pocet_statistik?: number;
          pocet_play_by_play?: number;
          chyby?: unknown[];
          error_message?: string | null;
          zaciatok?: string;
          koniec?: string | null;
          trvanie_v_sekundách?: number | null;
          created_at?: string;
        };
        Relationships: [];
      };
      nhl_hviezda_zapasu: {
        Row: {
          id: number;
          zapas_id: number;
          hrac_id: number | null;
          poradie: number;
          kategoria: string | null;
          hodnota: string | null;
          espn_hrac_id: string | null;
          meno_hraca: string;
          cislo_dresu: number | null;
          pozicia: string | null;
          tym_skratka: string | null;
          headshot_url: string | null;
          vytvorene: string;
          aktualizovane: string;
          // Nové štatistické polia
          goly: number;
          asistencie: number;
          body: number;
          strely_na_branu: number;
          cas_na_lade: string | null;
          plus_minus: number;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          hrac_id?: number | null;
          poradie: number;
          kategoria?: string | null;
          hodnota?: string | null;
          espn_hrac_id?: string | null;
          meno_hraca: string;
          cislo_dresu?: number | null;
          pozicia?: string | null;
          tym_skratka?: string | null;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
          // Nové štatistické polia
          goly?: number;
          asistencie?: number;
          body?: number;
          strely_na_branu?: number;
          cas_na_lade?: string | null;
          plus_minus?: number;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          hrac_id?: number | null;
          poradie?: number;
          kategoria?: string | null;
          hodnota?: string | null;
          espn_hrac_id?: string | null;
          meno_hraca?: string;
          cislo_dresu?: number | null;
          pozicia?: string | null;
          tym_skratka?: string | null;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
          // Nové štatistické polia
          goly?: number;
          asistencie?: number;
          body?: number;
          strely_na_branu?: number;
          cas_na_lade?: string | null;
          plus_minus?: number;
        };
        Relationships: [];
      };
      nhl_brankar_statistiky: {
        Row: {
          id: number;
          zapas_id: number;
          hrac_id: number | null;
          tym_id: number | null;
          espn_hrac_id: string | null;
          meno_hraca: string;
          cislo_dresu: number | null;
          zakroky: number;
          strely_na_branu: number;
          goly_inkasovane: number;
          percento_uspesnosti: number | null;
          cas_na_lade: string | null;
          je_vitaz: boolean;
          je_starter: boolean;
          headshot_url: string | null;
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          hrac_id?: number | null;
          tym_id?: number | null;
          espn_hrac_id?: string | null;
          meno_hraca: string;
          cislo_dresu?: number | null;
          zakroky?: number;
          strely_na_branu?: number;
          goly_inkasovane?: number;
          percento_uspesnosti?: number | null;
          cas_na_lade?: string | null;
          je_vitaz?: boolean;
          je_starter?: boolean;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          hrac_id?: number | null;
          tym_id?: number | null;
          espn_hrac_id?: string | null;
          meno_hraca?: string;
          cislo_dresu?: number | null;
          zakroky?: number;
          strely_na_branu?: number;
          goly_inkasovane?: number;
          percento_uspesnosti?: number | null;
          cas_na_lade?: string | null;
          je_vitaz?: boolean;
          je_starter?: boolean;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [];
      };
      nhl_tym_statistiky: {
        Row: {
          id: number;
          zapas_id: number;
          tym_id: number;
          je_domaci: boolean;
          blokovane_strely: number;
          strely_na_branu: number;
          strely_celkom: number;
          vyhry_vhadzovani: number;
          prehry_vhadzovani: number;
          percento_vhadzovani: number | null;
          presilove_hry: number;
          goly_v_presilke: number;
          percento_presilky: number | null;
          oslabenia: number;
          goly_v_oslabeni: number;
          trestne_minuty: number;
          hity: number;
          giveaway: number;
          takeaway: number;
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          tym_id: number;
          je_domaci: boolean;
          blokovane_strely?: number;
          strely_na_branu?: number;
          strely_celkom?: number;
          vyhry_vhadzovani?: number;
          prehry_vhadzovani?: number;
          percento_vhadzovani?: number | null;
          presilove_hry?: number;
          goly_v_presilke?: number;
          percento_presilky?: number | null;
          oslabenia?: number;
          goly_v_oslabeni?: number;
          trestne_minuty?: number;
          hity?: number;
          giveaway?: number;
          takeaway?: number;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          tym_id?: number;
          je_domaci?: boolean;
          blokovane_strely?: number;
          strely_na_branu?: number;
          strely_celkom?: number;
          vyhry_vhadzovani?: number;
          prehry_vhadzovani?: number;
          percento_vhadzovani?: number | null;
          presilove_hry?: number;
          goly_v_presilke?: number;
          percento_presilky?: number | null;
          oslabenia?: number;
          goly_v_oslabeni?: number;
          trestne_minuty?: number;
          hity?: number;
          giveaway?: number;
          takeaway?: number;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [];
      };
      nhl_hrac_statistiky: {
        Row: {
          id: number;
          zapas_id: number;
          hrac_id: number | null;
          tym_id: number | null;
          espn_hrac_id: string | null;
          meno_hraca: string;
          cislo_dresu: number | null;
          pozicia: string | null;
          kategoria: string | null;
          goly: number;
          asistencie: number;
          body: number;
          plus_minus: number;
          strely: number;
          blokovane_strely: number;
          hity: number;
          vyhrane_vhadzovanie: number;
          prehrane_vhadzovanie: number;
          cas_na_lade: string | null;
          je_active: boolean;
          je_scratched: boolean;
          headshot_url: string | null;
          vytvorene: string;
          aktualizovane: string;
        };
        Insert: {
          id?: number;
          zapas_id: number;
          hrac_id?: number | null;
          tym_id?: number | null;
          espn_hrac_id?: string | null;
          meno_hraca: string;
          cislo_dresu?: number | null;
          pozicia?: string | null;
          kategoria?: string | null;
          goly?: number;
          asistencie?: number;
          body?: number;
          plus_minus?: number;
          strely?: number;
          blokovane_strely?: number;
          hity?: number;
          vyhrane_vhadzovanie?: number;
          prehrane_vhadzovanie?: number;
          cas_na_lade?: string | null;
          je_active?: boolean;
          je_scratched?: boolean;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Update: {
          id?: number;
          zapas_id?: number;
          hrac_id?: number | null;
          tym_id?: number | null;
          espn_hrac_id?: string | null;
          meno_hraca?: string;
          cislo_dresu?: number | null;
          pozicia?: string | null;
          kategoria?: string | null;
          goly?: number;
          asistencie?: number;
          body?: number;
          plus_minus?: number;
          strely?: number;
          blokovane_strely?: number;
          hity?: number;
          vyhrane_vhadzovanie?: number;
          prehrane_vhadzovanie?: number;
          cas_na_lade?: string | null;
          je_active?: boolean;
          je_scratched?: boolean;
          headshot_url?: string | null;
          vytvorene?: string;
          aktualizovane?: string;
        };
        Relationships: [];
      };
    };
    Functions: {
      je_admin: {
        Args: Record<string, never>;
        Returns: boolean;
      };
      vytvor_alebo_ziskaj_hlas: {
        Args: { p_hlasovanie_id: string };
        Returns: string;
      };
      ziskaj_top_hracov: {
        Args: { p_hlasovanie_id: string; p_top_n?: number };
        Returns: VysledokSlotu[];
      };
      ziskaj_vysledky: {
        Args: { p_hlasovanie_id: string };
        Returns: VysledokSlotu[];
      };
      ziskaj_pocet_hlasov: {
        Args: { p_hlasovanie_id: string };
        Returns: number;
      };
      ziskaj_agregovane_vysledky: {
        Args: Record<string, never>;
        Returns: AgregovanyVysledok[];
      };
      ulozit_hlas: {
        Args: { p_hlasovanie_id: string; p_vybery: VyberInput[] };
        Returns: string;
      };
      schvalit_navrhhraca: {
        Args: { p_navrh_id: string; p_poznamka?: string };
        Returns: string;
      };
      zamietnut_navrhhraca: {
        Args: { p_navrh_id: string; p_poznamka: string };
        Returns: string;
      };
      kontrola_duplicity_hraca: {
        Args: { p_cele_meno: string };
        Returns: boolean;
      };
      vypocitaj_statistiky_zostavy: {
        Args: {
          p_hlas_id?: string;
          p_vybery?: VyberInput[];
        };
        Returns: StatistikyZostavy;
      };
      ziskaj_zoznam_narodenin_zostavy: {
        Args: {
          p_hlas_id?: string;
          p_vybery?: VyberInput[];
        };
        Returns: ZoznamNarodenin[];
      };
      spocitaj_vek: {
        Args: { p_datum_narodenia: string };
        Returns: number | null;
      };
      ziskaj_detail_kandidata: {
        Args: { p_kandidat_id: string };
        Returns: {
          kandidat_id: string;
          hrac_id: string;
          cele_meno: string;
          pozicia: PoziciaHraca;
          klub: string | null;
          sutaz: string | null;
          strana_hokejky: strana_hokejky | null;
          datum_narodenia: string | null;
          prijem: number;
          hodnota_hraca: number;
          poznamka: string | null;
          vytvorene: string;
          vek: number | null;
          nominacie_krajiny: string | null;
          nominacie_kody: string | null;
          cisla_dresov: string | null;
          priemerny_rating: number;
          pocet_hodnoteni: number;
          pocet_vyberov: number;
          sezona_zapasy: number;
          sezona_goly: number;
          sezona_asistencie: number;
          vek_k_ms: number | null;
          sezona_body: number;
          avatar_url: string | null;
          avatar_verzia: number;
          je_v_dispozicii: boolean;
          stav_zdravia: stav_zdravia;
          poznamka_zdravie: string | null;
          zdroj_povodu: string;
        }[];
      };
      prepocitaj_tabulku_skupiny: {
        Args: { p_skupina_id: string };
        Returns: void;
      };
      aplikuj_poradie_v_skupine: {
        Args: { p_skupina_id: string };
        Returns: void;
      };
      vypocitaj_celkove_poradie: {
        Args: Record<string, never>;
        Returns: void;
      };
      vygeneruj_playoff_zapasy: {
        Args: Record<string, never>;
        Returns: void;
      };
      ziskaj_pocet_registrovanych_pouzivatelov: {
        Args: Record<string, never>;
        Returns: number;
      };
      ziskaj_pocet_vsetkych_pouzivatelov: {
        Args: Record<string, never>;
        Returns: number;
      };
      uloz_navstevu: {
        Args: {
          p_hash_navstevnika: string;
          p_route: string;
          p_typ_udality: string;
        };
        Returns: string;
      };
      get_navstevy_statistiky: {
        Args: Record<string, never>;
        Returns: {
          unikatni_navstevnici: {
            dnes: number;
            "24h": number;
            "7dni": number;
            "30dni": number;
          };
          zobrazenia_stranok: {
            dnes: number;
            "24h": number;
            "7dni": number;
            "30dni": number;
          };
          registracie: {
            dnes: number;
            "24h": number;
            "7dni": number;
            "30dni": number;
          };
          konverzia: {
            dnes: number;
            "24h": number;
            "7dni": number;
            "30dni": number;
          };
        };
      };
      get_navstevy_top_stranky: {
        Args: {
          p_obdobie?: string;
        };
        Returns: {
          route: string;
          pocet_zobrazeni: number;
          unikatni_navstevnici: number;
        }[];
      };
      get_navstevy_casovy_rad: {
        Args: {
          p_obdobie?: string;
        };
        Returns: {
          datum: string;
          pocet_zobrazeni: number;
          unikatni_navstevnici: number;
        }[];
      };
      // NHL funkcie
      get_nhl_zapas_chronologia: {
        Args: { p_espn_game_id: string };
        Returns: NhlZapasChronologiaData[];
      };
      get_nhl_zapas_tim_statistiky: {
        Args: { p_espn_game_id: string };
        Returns: NhlZapasTimStatistika[];
      };
      get_nhl_zapas_hrac_statistiky: {
        Args: { p_espn_game_id: string };
        Returns: NhlZapasHracStatistika[];
      };
      get_nhl_zapas_info: {
        Args: { p_espn_game_id: string };
        Returns: NhlZapasInfo[];
      };
      import_nhl_zapas_data_from_espn: {
        Args: {
          p_zapas_id: number;
          p_espn_data: unknown;
          p_zdroj?: string;
        };
        Returns: {
          success: boolean;
          message: string;
          data?: unknown;
        };
      };
      import_nhl_play_by_play: {
        Args: {
          p_zapas_id: number;
          p_plays_data: unknown;
        };
        Returns: {
          inserted_count: number;
          updated_count: number;
          error_message: string | null;
        }[];
      };
    };
    Enums: {
      poziciahraca: PoziciaHraca;
      stav_zdravia: stav_zdravia;
      rola: Rola;
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
};

// =====================================================
// NHL Typy pre štatistiky a chronológiu
// =====================================================

export interface NhlTim {
  id: number;
  espn_tim_id: string;
  nazov: string;
  skratka: string;
  miesto: string | null;
  logo_url: string | null;
  farba_pozadia: string | null;
  farba_alternativa: string | null;
  aktivny: boolean;
}

export interface NhlZapas {
  id: number;
  espn_game_id: string;
  sezona_id: number;
  domaci_tim_id: number;
  hostiaci_tim_id: number;
  datum_zaciatku: string;
  datum_konca: string | null;
  stav_typ: string;
  stav_nazov: string;
  stav_skratka: string;
  perioda: number;
  cas_zapasu: string | null;
  cas_ostavajuci: number | null;
  domaci_skore: number;
  hostiaci_skore: number;
  venue_id: string | null;
  venue_nazov: string | null;
  venue_mesto: string | null;
  venue_stat: string | null;
  venue_krajina: string | null;
  venue_interior: boolean;
  venue_kapacita: number | null;
  attendance: number | null;
  neutral_site: boolean;
  play_by_play_available: boolean;
  recent: boolean;
  short_name: string;
  full_name: string;
  notes: unknown[];
  links: Record<string, unknown>;
  last_update: string;
  finalized_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface NhlZapasWithTeams extends NhlZapas {
  domaci_tim: NhlTim;
  hostiaci_tim: NhlTim;
  domaci_statistiky?: NhlZapasTimStatistika[];
  hostiaci_statistiky?: NhlZapasTimStatistika[];
}

export interface NhlZapasTimStatistika {
  tim_id: number;
  tim_nazov: string;
  tim_skratka: string;
  tim_strana: "domaci" | "hostiaci" | "unknown";
  stat_kluc: string;
  stat_nazov: string;
  stat_skratka: string;
  stat_hodnota: string;
  stat_cislo: number | null;
}

export interface NhlZapasHracStatistika {
  hrac_id: number;
  hrac_meno: string;
  hrac_cislo_dresu: number | null;
  tim_id: number;
  tim_nazov: string;
  tim_skratka: string;
  tim_strana: "domaci" | "hostiaci" | "unknown";
  stat_kluc: string;
  stat_nazov: string;
  stat_skratka: string;
  stat_hodnota: string;
  stat_cislo: number | null;
}

export interface NhlZapasStatsData {
  espn_game_id: string;
  datum_zaciatku: string;
  domaci_tim_id: number;
  hostiaci_tim_id: number;
  domaci_skore: number;
  hostiaci_skore: number;
  stav_nazov: string;
  tim_statistiky: NhlZapasTimStatistika[];
  hrac_statistiky: NhlZapasHracStatistika[];
}

export interface NhlZapasChronologiaUdalost {
  udalost_typ: string;
  sekvencia: number;
  perioda_udalosti: number;
  cas: string;
  cas_v_sekundach: number;
  popis: string;
  detailny_popis?: string;
  hrac_meno?: string;
  hrac_cislo?: number;
  hrac2_meno?: string;
  hrac2_cislo?: number;
  hrac3_meno?: string;
  hrac3_cislo?: number;
  tim_nazov?: string;
  tim_skratka?: string;
  tim_strana?: string;
  skore_po_gole?: string;
  trest_typ?: string;
  priorita: number;
}

export interface NhlZapasChronologiaData {
  espn_game_id: string;
  datum_zaciatku: string;
  domaci_nazov: string;
  hostiaci_nazov: string;
  domaci_skratka: string;
  hostiaci_skratka: string;
  domaci_skore: number;
  hostiaci_skore: number;
  stav_nazov: string;
  udalosti: NhlZapasChronologiaUdalost[];
}

export interface NhlZapasInfo {
  id: number;
  espn_game_id: string;
  datum_zaciatku: string;
  domaci_tim_id: number;
  hostiaci_tim_id: number;
  domaci_skore: number;
  hostiaci_skore: number;
  stav_nazov: string;
}

export interface ApiResponse<T = unknown> {
  data: T | null;
  source: "database" | "database_empty" | "espn_api";
  fallback?: string;
  error?: string;
  message?: string;
}
